/* shadcn 커스텀 컴포넌트 - alert-dialog 수정 컴포넌트 */

import * as React from 'react';
import { AlertDialogAction as RadixAlertDialogAction, AlertDialogCancel as RadixAlertDialogCancel } from '@radix-ui/react-alert-dialog';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTrigger,
  AlertDialogTitle,
  AlertDialogDescription,
} from '@/shared/shadcn/raw/alert-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

import { cn } from '@/shared/shadcn/lib/utils';
import CustomButton from '@/shared/shadcn/custom/CustomButton';

/** 외부 클릭을 막고 ESC는 허용하는 Overlay */
function CustomOverlay(props: React.ComponentProps<typeof AlertDialogOverlay>) {
  return (
    <AlertDialogOverlay
      {...props}
      onClick={(e) => {
        e.stopPropagation();
      }}
    />
  );
}

function CustomAlertDialogContent({
  children,
  className,
  title,
  description,
  ...props
}: React.ComponentProps<typeof AlertDialogContent> & { title?: string; description?: string }) {
  return (
    <AlertDialogPortal>
      <CustomOverlay />
      <AlertDialogContent className={cn('gap-0', className)} {...props}>
        <AlertDialogTitle>
          <VisuallyHidden>{title}</VisuallyHidden>
        </AlertDialogTitle>
        <AlertDialogDescription>
          <VisuallyHidden>{description}</VisuallyHidden>
        </AlertDialogDescription>
        {children}
      </AlertDialogContent>
    </AlertDialogPortal>
  );
}

/** 기본 AlertDialogCancel을 CustomButton으로 교체 ( 기본 shadcn 버튼에 있는 스타일 제거 ) */
function CustomAlertDialogCancel(props: React.ComponentProps<typeof CustomButton>) {
  return (
    <RadixAlertDialogCancel asChild>
      <CustomButton {...props} />
    </RadixAlertDialogCancel>
  );
}
/** 기본 AlertDialogAction을 CustomButton으로 교체 ( 기본 shadcn 버튼에 있는 스타일 제거 ) */
function CustomAlertDialogAction(props: React.ComponentProps<typeof CustomButton>) {
  return (
    <RadixAlertDialogAction asChild>
      <CustomButton {...props} />
    </RadixAlertDialogAction>
  );
}

// 내보내기
export {
  AlertDialog as CustomAlertDialog,
  AlertDialogTrigger as CustomAlertDialogTrigger,
  CustomAlertDialogContent,
  AlertDialogTitle as CustomAlertDialogTitle,
  AlertDialogDescription as CustomAlertDialogDescription,
  CustomAlertDialogCancel,
  CustomAlertDialogAction,
};
